import { apiFetch } from '@/platform/lib/api';

export type ReportTargetType =
  | 'forum_post'
  | 'forum_comment'
  | 'group_post'
  | 'vendor_product'
  | 'user';

export type ReportReason =
  | 'spam'
  | 'harassment'
  | 'hate'
  | 'sexual'
  | 'illegal'
  | 'scam'
  | 'other';

export type ContentReport = {
  id: string;
  reporterId: string;
  targetType: ReportTargetType;
  targetId: string;
  parentId?: string;
  sellerUserId?: string;
  reportedUserId?: string;
  reason: ReportReason | string;
  note?: string;
  status: string;
  adminNote?: string;
  createdAt?: string;
};

export function createContentReport(body: {
  targetType: ReportTargetType;
  targetId: string;
  parentId?: string;
  sellerUserId?: string;
  reportedUserId?: string;
  reason: ReportReason;
  note?: string;
}) {
  return apiFetch<ContentReport>('/moderation/reports', {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

export function listAdminReports(status: string = 'open') {
  return apiFetch<{ reports: ContentReport[] }>(
    `/admin/moderation/reports?status=${encodeURIComponent(status)}`,
  );
}

export function patchAdminReport(id: string, body: { status: 'dismissed' | 'actioned'; adminNote?: string }) {
  return apiFetch<ContentReport>(`/admin/moderation/reports/${encodeURIComponent(id)}`, {
    method: 'PATCH',
    body: JSON.stringify(body),
  });
}

export function blockUser(userId: string) {
  return apiFetch<{ status: string }>('/moderation/blocks', {
    method: 'POST',
    body: JSON.stringify({ userId }),
  });
}

export function unblockUser(userId: string) {
  return apiFetch<{ status: string }>(`/moderation/blocks/${encodeURIComponent(userId)}`, {
    method: 'DELETE',
  });
}

export function listBlockedUsers() {
  return apiFetch<{ blocks: Array<{ userId: string }> }>('/moderation/blocks');
}

export function adminHideVendorProduct(sellerUserId: string, productId: string) {
  return apiFetch(`/admin/vendors/${encodeURIComponent(sellerUserId)}/products/${encodeURIComponent(productId)}/moderate`, {
    method: 'POST',
    body: JSON.stringify({ action: 'hide' }),
  });
}
